import React, { Component } from "react";
import { apiReadOneAsset } from "../../../../utils/apis.js"
import Dialog from "../../../dialogs/dialog.js";
import Transcript from "../transcript/transcript.js";

import { keyboard_multi_getKey, keyboard_multi_getShorCutList_by_apps_and_keyboard } from '../../../../utils/keyboard_multi.js';

import "./assetsmanager.css"



class DisplayTranscript extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        en:"Transcription", 
        fr:"Transcription",
      };
    this.state.title = title;

    this.state.buttons = 
    [
      {type:"back", disabled:false},
      
    ]

    this.handleButton =  this.handleButton.bind(this);
    this.apicallback = this.apicallback.bind(this)

    this.onQuit = this.onQuit.bind(this)
    this.transcriptRef = React.createRef();

    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.state.timecodeAsset = this.props.asset;
    this.shortcuts_list = [];


    
  }


componentDidMount()
{
    super.componentDidMount()
    this.shortcuts_list =keyboard_multi_getShorCutList_by_apps_and_keyboard(["transcription"]);
    var datas = {asid: this.props.asset.asid};
    
    apiReadOneAsset (datas, this.apicallback)

    window.addEventListener('keydown', this.handleKeyDown);
}

componentWillUnmount()
{
    window.removeEventListener('keydown', this.handleKeyDown);
}

componentDidUpdate()
{
  console.log("component did update ", this.state.title.fr)
}

handleKeyDown = (event) =>
    {



      if (this.transcriptRef && this.transcriptRef.current) {
        var key = keyboard_multi_getKey("transcription",
          this.shortcuts_list,
          event.key,
          event.shiftKey,
          event.ctrlKey,
          event.altKey
        );
  
        
        if (key !== '') {
          event.preventDefault();
          this.transcriptRef.current.processShortcut(key);
          return;
        }
        
        var char = event.key;
        if (char.length === 1) {
          var code = char.codePointAt(0);
          if (code >= 32) this.transcriptRef.current.addChar(event.key);
        }
  
        return;
      }
  



      var char = event.key;
      if (char.length == 1)
      {
        var code = char.codePointAt(0);
        if (code >= 32) this.transcriptRef.current.addChar (event.key);
      }          
    }



 apicallback(datas)
 {
    
    if (datas.ret)
    {

          var alldatas = JSON.parse(datas.asdatas);
          var transcription = alldatas;
          if ("transcription" in alldatas)
              transcription = alldatas.transcription;

        console.log("datas = ", datas)
        this.transcriptRef.current.setTranscription(transcription,this.props.asset.asid,-1,this.props.asset.astitle,this.props.asset.asfile);
    }
    
 }
  onQuit()
  {
    this.props.onButton("back");    
  }


  handleButton(buttonkey)
  {
    console.log("on click", buttonkey)
    if (buttonkey === "back")
        this.props.onButton("back");
    
  }

  
  render()
  {
    var maxwidth =  (window.innerWidth * 60)/100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 500) maxheight = 500;


    var retour = [<></>];
    if (this.props.display)
    {

        retour =
        (
          <div style = {{width:maxwidth, height: maxheight}}>
            
                <Transcript ref = {this.transcriptRef}
                        readonly={true}   
                        timecodeAsset = {this.state.timecodeAsset}                
                        initialFontSize = {13}
                        showSpeakers={false}
                            />

          </div>
        )
      }
    return super.render(retour);
  }


}


export default DisplayTranscript;